// extracted by mini-css-extract-plugin
module.exports = {"container":"_1uCwB","inline":"_2_ekU","hideCurrency":"_2hZzJ","currency":"_3__Vg","emphasis":"mN9Rp","currencySymbol":"_1Myms","condensed":"-apFs","big":"_1U82I","bigger":"_3X3oI"};